const DinoEgg = () => {
  return (
    <>
      <div className="absolute">
        <section
          id="hero"
          className="bg-[url('/img/hero.png')] bg-center bg-cover"
        >
          <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
        </section>
        <section id="user-guide" className="">
          <div className="bg-gradient-to-b from-black/[70%] to-black/[100%] inset-0 w-screen h-screen"></div>
        </section>
      </div>
      <div className="absolute w-screen top-[20%] landscape:top-[30%]">
        <div className="container mx-auto flex flex-col items-center justify-center w-full">
          <div className="flex flex-col items-center space-y-7 md:space-y-14">
            <div>
              <span className="uppercase text-2xl md:text-6xl text-primary font-primary">
                Dino Egg NFT Sale
              </span>
            </div>
            <span className="uppercase text-xl md:text-2xl text-primary font-primary">
              Comming soon
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default DinoEgg;
